import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../store/auth/auth.store';

export const authGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Se la rotta è /auth/change-password
  if (state.url === '/auth/change-password') {
    if (authStore.isFirstAccess && typeof authStore.isFirstAccess === 'function' ? authStore.isFirstAccess() : authStore.isFirstAccess) {
      return true;
    }
    return router.createUrlTree(['/auth/login']);
  }

  if (state.url === '/auth/login') {
    if (authStore.isAuthenticated()) {
      // Permetti il passaggio se la navigazione proviene da un logout esplicito
      const currentNavigation = router.getCurrentNavigation();
      if (currentNavigation?.extras?.state?.['isLoggingOut']) {
        return true;
      }
      return router.navigate(['/home']);
    }
    return true;
  }

  // Per tutte le altre rotte
  if (authStore.isAuthenticated && typeof authStore.isAuthenticated === 'function' ? authStore.isAuthenticated() : authStore.isAuthenticated) {
    if (authStore.isFirstAccess && typeof authStore.isFirstAccess === 'function' ? !authStore.isFirstAccess() : !authStore.isFirstAccess) {
      return true;
    }
  }

  return router.createUrlTree(['/auth/login']);
}; 